export let snackbarOption = { /*快速提示框*/
    show: false,
    hintType: '',
    text: ' Error ',
    timeout: 4000,
    typeEnum: {
        success: 'success',
        info: 'info',
        error: 'error',
        cyan: 'cyan'
    }
}


// WEBPACK FOOTER //
// ./src/common/js/snackbar.js